// Membership.js
import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const Membership = () => {
  const navigate = useNavigate();

  const goToQuiz = useCallback(() => {
    navigate("/");
    setTimeout(() => {
      const el = document.getElementById("quiz-section");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 300);
  }, [navigate]);

  return (
    <section className="membership-root" aria-label="VyBly Membership">
      <style>{`
        :root{
          --bg-dark:#0b1a22;
          --bg-deep:#0e2430;
          --teal-500:#1f6c75;
          --teal-400:#2a8d96;
          --teal-300:#49b1ba;
          --aqua-200:#7edce2;
          --gold-500:#f5b400;
          --text:#f4fbfc;
          --muted:#cfe1e4;
          --card:#0f2a36cc;
          --ring:#2bb3bf55;
        }

        *{box-sizing:border-box}

        .membership-root {
          position: fixed;
          top: 0; left: 0;
          width: 100vw;
          height: 100vh;

          color: var(--text);
          background-color: var(--bg-dark);
          background-image:
            radial-gradient(1200px 700px at 20% -10%, var(--teal-400) 0%, transparent 60%),
            radial-gradient(1000px 600px at 85% 30%, var(--teal-500) 0%, transparent 55%),
            linear-gradient(180deg, var(--bg-dark), var(--bg-deep));
          background-repeat: no-repeat;
          background-size: cover;

          font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
        }

        /* scrollable area ensures scrollbar is far right */
        .scroll-area {
          width: 100%;
          height: 100%;
          overflow-y: auto;
          padding: clamp(28px, 5vw, 64px);
        }

        /* margin at top for header clearance */
        @media (max-width: 960px) {
          .wrap {
            margin-top: 80px;
          }
        }
        @media (min-width: 961px) {
          .wrap {
            margin-top: 60px;
          }
        }

        .hex{
          position:absolute;
          width:clamp(60px, 9vw, 120px);
          aspect-ratio:1/1;
          background:var(--aqua-200);
          clip-path: polygon(25% 6.7%,75% 6.7%,100% 50%,75% 93.3%,25% 93.3%,0% 50%);
          filter: drop-shadow(0 12px 24px #0006);
          opacity:.85;
          animation: float 12s ease-in-out infinite;
          pointer-events:none;
        }
        .hex.teal{ background: var(--teal-300); }
        .hex.a{ top:6%; left:12%; animation-delay: -2s; }
        .hex.b{ top:28%; right:16%; transform:scale(.9); animation-delay:-6s;}
        .hex.c{ bottom:18%; right:8%; transform:scale(1.05); }
        .hex.d{ bottom:8%; left:6%; transform:scale(.75); animation-delay:-3s;}
        @keyframes float{
          0%,100%{ transform:translateY(0) rotate(0deg) }
          50%{ transform:translateY(-16px) rotate(6deg) }
        }

        .wrap{ width:min(960px, 100%); position:relative; z-index:1; margin-inline:auto; }
        .hero{ text-align:center; }

        .title{
          font-weight:900;
          line-height:1.05;
          letter-spacing:-0.02em;
          font-size: clamp(38px, 6vw, 72px);
          margin:0 0 16px;
          text-shadow: 0 2px 0 #0004, 0 10px 28px #0009;
        }
        .subtitle{
          color:var(--muted);
          font-size: clamp(16px, 2.2vw, 20px);
          line-height:1.65;
          margin:0 0 40px;
        }

        .card{
          background: var(--card);
          border:1px solid var(--ring);
          border-radius: 22px;
          padding: clamp(24px, 3vw, 32px);
          backdrop-filter: blur(10px);
          box-shadow: 0 14px 34px #0009, inset 0 1px 0 #ffffff12;
          text-align:center;
          margin-bottom: 24px;
        }

        .price{
          font-size: clamp(28px, 4vw, 36px);
          font-weight:800;
          margin-bottom:12px;
          color: var(--aqua-200);
        }

        .desc{
          color: var(--text);
          font-size: clamp(16px, 2vw, 18px);
          line-height:1.5;
          margin-bottom:20px;
        }

        .btn{
          appearance:none; border:none; cursor:pointer;
          padding:14px 22px;
          border-radius:16px;
          font-weight:800;
          letter-spacing:.3px;
          background:linear-gradient(180deg,var(--teal-300),var(--teal-400));
          color:#0a1216;
          box-shadow: 0 12px 26px #0008, 0 0 0 4px #00000010;
          transition: transform .12s ease, filter .12s ease;
        }
        .btn:hover{ transform: translateY(-2px); filter:brightness(1.05); }

        .free-card {
          background: #123a4499;
          border:2px dashed var(--aqua-200);
          border-radius: 20px;
          padding: 24px;
          margin-top: 28px;
          text-align:center;
        }

        .free-card strong {
          display:block;
          font-size: 18px;
          margin-bottom:6px;
          color: var(--aqua-200);
        }

        .free-card p {
          font-size: 16px;
          color: var(--muted);
          margin: 0;
        }

        .wave{
          position:absolute; left:0; right:0; bottom:-1px; height:140px; width:100%;
          z-index:0;
        }
      `}</style>

      {/* Decorative hexes */}
      <span className="hex a" />
      <span className="hex teal b" />
      <span className="hex c" />
      <span className="hex teal d" />

      <div className="scroll-area">
        <div className="wrap hero">
          <h1 className="title">Membership</h1>
          <p className="subtitle">Simple, flexible, and built for how you work.</p>

          {/* Paid option */}
          <div className="card">
            <div className="price">$1.99</div>
            <div className="desc">
              1 hour Frameworks session<br/>
              Pay only for what you use.
            </div>
            <button className="btn" onClick={goToQuiz}>Get Started</button>
          </div>

          {/* Free messaging */}
          <div className="free-card">
            <strong>First session is free.</strong>
            <p>Hivemind itself is free to use.</p>
          </div>
        </div>
      </div>

      <svg className="wave" viewBox="0 0 1440 140" preserveAspectRatio="none" aria-hidden>
        <path fill="#49b1ba" d="M0,112 C180,164 320,24 540,60 C760,96 960,180 1440,64 L1440,140 L0,140 Z"/>
      </svg>
    </section>
  );
};

export default Membership;
